
/* injects from baggage-loader */

import { fill, clone, random, sampleSize } from 'lodash';


const tamanduaA = require('_images/stages/stage-four/tamandua-1.png');
const tamanduaB = require('_images/stages/stage-four/tamandua-2.png');

export const excludedSquads = [10, 48, 49];

export const TrashTypes = [
    {
        type: 'cd',
        label: 'o <b>CD</b>',
        image: require('_images/stages/stage-four/objects/cd.png'),
        selectable: true
    },
    {
        type: 'tin',
        label: 'a <b>Lata</b>',
        image: require('_images/stages/stage-four/objects/tin.png'),
        selectable: true
    },
    {
        type: 'bottle',
        label: 'a <b>Garrafa de vidro</b>',
        image: require('_images/stages/stage-four/objects/bottle.png'),
        selectable: true
    },
    {
        type: 'box',
        label: 'a <b>Caixa de papelão</b>',
        image: require('_images/stages/stage-four/objects/box.png'),
        selectable: true
    },/*
    {
        type: 'bush',
        label: 'o Arbusto',
        image: require('_images/stages/stage-four/objects/bush.png'),
        selectable: false
    },
    {
        type: 'bush-dark',
        label: 'o Arbusto escuro',
        image: require('_images/stages/stage-four/objects/bush-dark.png'),
        selectable: false
    },
    {
        type: 'bush-light',
        label: 'o Arbusto claro',
        image: require('_images/stages/stage-four/objects/bush-light.png'),
        selectable: false
    },*/
    {
        type: 'glasses',
        label: 'os <b>Óculos</b>',
        image: require('_images/stages/stage-four/objects/glasses.png'),
        selectable: true
    },
    {
        type: 'mirror',
        label: 'o <b>Espelho</b>',
        image: require('_images/stages/stage-four/objects/mirror.png'),
        selectable: true
    },
    {
        type: 'plastic',
        label: 'a <b>Garrafa plástica</b>',
        image: require('_images/stages/stage-four/objects/plastic.png'),
        selectable: true
    }
]

export default function (app) {
    app
        .factory('TamanduaCanvas', TamanduaCanvas);
    
    function TamanduaCanvas() {
        'ngInject';
        let self = {}

        self.createPlayer = function(type, positionNull = false){
            return self.Player(type, positionNull);
        }

        self.createCanvas = function(rows = 5, columns = 10){
            let emptySquads  = fill(Array(columns * rows), {});
            let squads = self.createPositions(rows, columns, emptySquads);
            let objects = self.createObjects();

            objects.forEach(o => {
                let randomIndex = self.genRandom(squads);
                if (squads[randomIndex].objects.length) return;
                squads[randomIndex].objects.push(o);
            });

            return squads;
        }

        self.createPositions = function(rows, columns, array){
            return array.map((value, index) => {
                let newValue = clone(value);
                let counter = index + 1;
                
                let x = counter > 10 ? parseInt( counter.toString().substr(-1) ) : counter;
                let y = Math.ceil(counter / columns);
                
                newValue.position = {
                    x: x ? x : 10,
                    y: y
                };

                newValue.players = [];
                newValue.objects = [];
                
                return newValue;
            });
        }

        self.createObjects = function(maxItems=16){
            let totalItems = random( Math.abs(maxItems / 2), maxItems );
            //let items = fill( Array(totalItems),{});
            return sampleSize(TrashTypes,totalItems);
        }

        self.genRandom = function(squads){
            let number = random(10, squads.length - 10); // 10 and -10 for trap player    
            return excludedSquads.includes(number) ? self.genRandom(squads) : number;
        }

        // Models
        self.Player = function(type, positionNull = false){
            let position = positionNull 
                ? null
                : { x: 1, y: 1 }
            
            return {
                position,
                type: type,
                events: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0
                },
                sequence: [],
                image: type === "A" ? tamanduaA : tamanduaB,
                selected: false
            }
        }

        self.Trash = function(){
            let randomIndex = random(0, TrashTypes.length - 1);
            let trash = TrashTypes[randomIndex];
            return trash;
        }

        return self
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/tamandua-canvas/tamandua-canvas.factory.js